import PagesController from 'controllers/PagesController';
import ComponentsManager from "controllers/ComponentsManager";
import Projects from './Projects';
import ProjectsHeader from "./ProjectsHeader";
import ProjectCardThumbnail from "./ProjectCardThumbnail";
import TOC from "./TOC";
import TransitionProjectCardTitle from "./TransitionProjectCardTitle";


export default new class {
	constructor() {
		PagesController.addPage('projects', Projects);
		ComponentsManager.register('projects_header', ProjectsHeader);
		ComponentsManager.register('project_card_thumbnail', ProjectCardThumbnail);
		ComponentsManager.register('toc', TOC);
		ComponentsManager.register('transition_project_card_title', TransitionProjectCardTitle);
	}


};
